import React, { lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
const lazyNamed = (loader, name) => lazy(() => loader().then((m) => ({ default: m[name] })));
const SOS = lazy(() => import("@/pages/SOS"));
const Journal = lazy(() => import("@/pages/Journal"));
const Progress = lazy(() => import("@/pages/Progress"));
const Solutions = lazy(() => import("@/pages/Solutions"));
const Challenges = lazy(() => import("@/pages/Challenges"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const Login = lazy(() => import("@/pages/Login"));
const Account = lazy(() => import("@/pages/Account"));
const Program = lazy(() => import("@/pages/Program"));
const Coach = lazy(() => import("@/pages/Coach"));
const PaymentSuccess = lazyNamed(() => import("@/pages/PaymentResult"), "PaymentSuccess");
const PaymentCancel = lazyNamed(() => import("@/pages/PaymentResult"), "PaymentCancel");
const Privacy = lazyNamed(() => import("@/pages/Legal"), "Privacy");
const Terms = lazyNamed(() => import("@/pages/Legal"), "Terms");
const Support = lazyNamed(() => import("@/pages/Legal"), "Support");
const VerifyEmail = lazy(() => import("@/pages/VerifyEmail"));
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Detect Google OAuth return synchronously (before any auth check)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/sos" element={<SOS />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/progres" element={<Progress />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/defis" element={<Challenges />} />
        <Route path="/programme" element={<Program />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/tarifs" element={<Pricing />} />
        <Route path="/connexion" element={<Login />} />
        <Route path="/compte" element={<Account />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/confidentialite" element={<Privacy />} />
        <Route path="/conditions" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/verifier-email" element={<VerifyEmail />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
